/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { formValues } from 'redux-form';
import FieldsArray from './../FieldsArray';
import PriceFieldset from './PriceFieldset';
import InfoLink from '../../InfoLink';
import PriceBreakdown from '../../PriceBreakdown';
import FormField from '../FormField'
import {CardBody} from 'reactstrap'
const emptyPrices = (error) => (error && typeof(error) !== 'object');

const Prices = ({formErrors, currencies, pricing_type}) => (
  <div>
    <div className="mb-2">
      <strong>Price to attend your event</strong>
      <InfoLink link="https://support.evvnt.com/hc/en-us/articles/360020923893-Tickets-What-are-your-ticket-types"/>
    </div>
    {emptyPrices(formErrors.get('prices')) && (
      <div className="text-danger">
        Add your ticket price
      </div>
    )}
    <FieldsArray
      name="prices"
      component={PriceFieldset}
      formErrors={formErrors}
      resourceName="Ticket"
      additionalActionClassName="col-12 col-md-6"
      currencies={currencies}
      max={pricing_type === 'registration_required' ? 1 : 10}
    />
  </div>
);

Prices.propTypes = {
  currencies: PropTypes.array.isRequired,
  formErrors: PropTypes.object,
  pricing_type: PropTypes.string,
};

const PricingFieldset = formValues({
  pq: 'pricing_type',
  ticketing_url_type: 'ticketing_url_type',
  currency: 'currency',
  prices: 'prices',
})(({ pq, currency, currencies, formErrors, ticketing_url_type, prices }) => {
  const addCommas = value => {
    const onlyNums = value.replace(/[^\d]/g, '');
    return onlyNums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  if (pq === 'tickets_in_advance') {
    return (
      <div>
        <div className="mt-2">
          <Prices formErrors={formErrors} currencies={currencies} currency={currency} pricing_type={pq}/>
          {ticketing_url_type === 'geotix' && pq === 'tickets_in_advance' && prices.length &&
            <PriceBreakdown price={prices[prices.length - 1].price} absoluteClass={true}/>}
        </div>
        <div className="row">
          <div className="col-md-4">
            <FormField
              name="capacity"
              label="Capacity"
              error={formErrors.get('capacity')}
              component="input"
              type="text"
              className="form-control"
              placeholder="Enter the number of attendees"
              normalize={addCommas}
              required={ticketing_url_type === 'geotix'}
            />
          </div>
        </div>
      </div>
    );
  } else{
    return null;
  }
});

PricingFieldset.propTypes = {
  currencies: PropTypes.array.isRequired,
  formErrors: PropTypes.object,
};

export default PricingFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/PricingFieldset.jsx